import Cookies from "js-cookie";
import {
  ACCOUNT_ID_COOKIE,
  ACCOUNT_ID_DEFAULT_EXPIRE_TIME,
  PREFFERED_COIN_COOKIE,
  PREFFERED_COIN_DEFAULT_EXPIRE_TIME,
  USER_ID_COOKIE,
  USER_ID_DEFAULT_EXPIRE_TIME,
  USERNAME_COOKIE,
  USERNAME_DEFAULT_EXPIRE_TIME,
  WILDCARDS_DOMAIN,
} from "../common/const";
import AnalyticsService from "@emcd-shared/analytics-service";
import { AuthServiceCore } from "../index";
// roles
import CUSTOMER_ACTIONS from "./roles/customer/actions";

export default {
  authenticate({ commit, dispatch }, payload) {
    const { access_token, refresh_token, userData } = payload;
    commit("SAVE_ACCESS_TOKEN", access_token);
    commit("SAVE_REFRESH_TOKEN", refresh_token);
    commit("SAVE_USER_DATA", userData);

    const savedId = Cookies.get(ACCOUNT_ID_COOKIE)
    if (savedId) {
      const isSavedIdIsUUID = Number.isNaN(Number(savedId))
      const UUID = isSavedIdIsUUID ? savedId : userData?.user_id
      dispatch("setAccountID", UUID);
    } else {
      dispatch("setAccountID", userData?.user_id);
    }
    // * UserID (only main account id)
    const userID = userData?.user_id;
    if (userID) {
      dispatch("setUserID", userID);
    } else {
      AnalyticsService.error("empty userID");
    }
    // * Username (sub_account or main account username)
    const username = Cookies.get(USERNAME_COOKIE) || userData.username;
    if (username) {
      dispatch("setUsername", username);
    } else {
      AnalyticsService.error("empty username");
    }
    // * Preferred CryptoCoin
    const crypto = Cookies.get(PREFFERED_COIN_COOKIE);
    if (crypto) {
      commit("SAVE_PREFERRED_CRYPTO", crypto);
    }
  },
  identify({ commit }, payload) {
    const { fingerprint, systemInfo } = payload;
    commit("SAVE_FINGERPRINT", fingerprint);
    commit("SAVE_SYSTEM_INFO", systemInfo);
  },
  setAccountID({ commit }, ID) {
    let cookieDomain = AuthServiceCore.getDomain();
    if (!cookieDomain) {
      AnalyticsService.error(`Unsupported domain ${window.location.hostname}`);
    }
    Cookies.set(ACCOUNT_ID_COOKIE, ID, {
      domain: cookieDomain,
      expires: ACCOUNT_ID_DEFAULT_EXPIRE_TIME,
    });
    commit("SAVE_ACCOUNT_ID", ID);
  },
  setUserID({ commit }, ID) {
    let cookieDomain = AuthServiceCore.getDomain();
    if (!cookieDomain) {
      AnalyticsService.error(`Unsupported domain ${window.location.hostname}`);
    }
    Cookies.set(USER_ID_COOKIE, ID, {
      domain: cookieDomain,
      expires: USER_ID_DEFAULT_EXPIRE_TIME,
    });
  },
  setUsername({ commit }, payload) {
    let cookieDomain = AuthServiceCore.getDomain();
    if (!cookieDomain) {
      AnalyticsService.error(`Unsupported domain ${window.location.hostname}`);
    }
    Cookies.set(USERNAME_COOKIE, payload, {
      domain: cookieDomain,
      expires: USERNAME_DEFAULT_EXPIRE_TIME,
    });
    commit("SAVE_USERNAME", payload);
  },
  switchSubAccount({ getters, dispatch, state }, payload) {
    const { id } = payload;
    if (!id) {
      AnalyticsService.error("incorrect subaccount data");
    }
    const account =
      state.customer.identifier.id === id ? state.customer : state.sub[id];
    dispatch("setAccountID", account.identifier.id);
    dispatch("setUsername", account.identifier.username);
  },
  saveAccountList({ commit }, payload) {
    commit("SAVE_ACCOUNT_LIST", payload);
  },

  setPreferredCrypto({ commit }, payload) {
    let cookieDomain = AuthServiceCore.getDomain();
    if (!cookieDomain) {
      AnalyticsService.error(`Unsupported domain ${window.location.hostname}`);
    }
    Cookies.set(PREFFERED_COIN_COOKIE, payload, {
      domain: cookieDomain,
      expires: PREFFERED_COIN_DEFAULT_EXPIRE_TIME,
    });
    commit("SAVE_PREFERRED_CRYPTO", payload);
  },
  async loadProfile({ commit, getters, dispatch }, EmcdApi) {
    try {
      const res = await EmcdApi.get(
        `/v1/dashboard${getters.isSub ? `/${getters.accountID}` : ""}`
      );
      const profileData = res?.dashboard?.[0];
      if (!profileData) {
        throw new Error("incorrect response body");
      }
      commit("SAVE_PROFILE", profileData || {});
      if (profileData?.username) {
        dispatch("setUsername", profileData?.username);
      }
      return profileData;
    } catch (err) {
      AnalyticsService.addBreadcrumb(
        "AuthService.loadAccountList",
        "response.error"
      );
      if (err.response) {
        AnalyticsService.log(err.response.status);
        AnalyticsService.log(JSON.stringify(err.response.data));
        AnalyticsService.log(JSON.stringify(err.response.headers));
      }
      if (err.request) {
        AnalyticsService.log(err.request.status);
        AnalyticsService.log(JSON.stringify(err.request.data));
        AnalyticsService.log(JSON.stringify(err.request.headers));
      }
      AnalyticsService.error(err);
    }
  },
  async loadSecure({ commit }, endpointApi = null) {
    if (!endpointApi) {
      console.warn(
        "AuthService-loadSecure/Need endpointApi argument to loadSecure action"
      );
    } else {
      try {
        const response = await endpointApi.get("/profile/2fa_setup");
        if (response) {
          commit("SAVE_SECURE", response);
        } else {
          throw new Error("empty secure response");
        }
      } catch (e) {
        throw new Error(e);
      }
    }
  },
  async fetchGetLanguage({ commit }, endpointApi = null) {
    if (!endpointApi) {
      console.warn(
        "[AuthService-fetchGetLanguage] Need endpointApi argument to fetchGetLanguage action"
      );

      return;
    }

    try {
      return await endpointApi.get("/profile/language");
    } catch (e) {
      throw new Error(e);
    }
  },

  async fetchSetLanguage({ commit }, { endpointApi = null, language = null }) {
    if (!endpointApi) {
      console.warn(
        "[AuthService-fetchSetLanguage] Need endpointApi argument to fetchSetLanguage action"
      );
      return;
    }

    try {
      return await endpointApi.post("/profile/language", { language });
    } catch (e) {
      throw new Error(e);
    }
  },

  ...CUSTOMER_ACTIONS,
};
